import { Box,Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAppTheme } from "../../../context/ThemeContext";

export default function AdminTeamStandings(){
  const [searchParams]=useSearchParams();
  const {colors,typography,shape}=useAppTheme();
  const category=searchParams.get("category")||"";

  return (
    <Box
      sx={{
        p:2,
        border:`1px solid ${colors.border}`,
        borderRadius:shape.radiusLarge,
        backgroundColor:colors.surface
      }}
    >
      <Typography sx={{fontSize:typography.sizes.lg,fontWeight:700,color:colors.text}}>
        Tabla
      </Typography>

      <Typography sx={{mt:0.5,fontSize:typography.sizes.sm,color:colors.textSecondary}}>
        Aquí se administrará la información deportiva del equipo{category?` para la categoría ${category}`:""}.
      </Typography>
    </Box>
  );
}